import LazyLoad from 'vanilla-lazyload';
import ButtonEvents from './modules/button-events';
import DesktopTree from './modules/desktop-tree';
/*import ConsentBar from './modules/general/consent-bar';*/
/*import { readConsentCookie } from './modules/general/consent-manager';*/
import Rwd from './modules/general/rwd';
import DesktopProducersTree from './modules/desktop-producers-tree';
import Newsletter from './modules/newsletter';
import PjaxCode from './modules/pjax-code';
import FilterLoader from './modules/filter-loader';
import FilterTracking from './modules/listing/filter-tracking';
import GaListing from './modules/listing/ga-listing';
import StickyFilters from './modules/listing/sticky-filters';
import ScrollRow from './modules/listing/scroll-row';
import PriceFiltering from './modules/price-filtering';
import ProductTemplate from './modules/product-template';
import TextWrap from './modules/text-wrap';
import ProductAdder from './modules/product-adder';
import smallCartRefresh from './modules/cart/small-cart-refresh';
import DropdownPicker from './modules/dropdown-picker';
//import Tabs from './modules/tabs';
import EventReceiver from './modules/utils/event-receiver';
import { WishlistBinding, WishlistDrawing } from './modules/wishlist';
import CalculateFreeShipment from './modules/general/calculate-free-shipment';
import QuestionForm from './modules/question-form';
import LoginPopup from './modules/login-popup';
import Showcase from './modules/general/showcase';
import initObserver from './modules/general/observer';
import VideoPlaceholders from './modules/video-placeholders';
import RmaForm from './modules/rma-form';
import Faqs from './modules/faqs';
import DetailMain from './modules/product-detail';
import ShowPopup from './modules/modals';
import { on } from 'delegated-events';
import { whenIdle } from './modules/utils/utils';
import CopyLink from './modules/copy-link';
performance.mark("App start")


/*window.initConsent = readConsentCookie;*/

//available types of body: cart, listing, detail, mainpage, advanced-search, user-management, cms
const typeOf = document.body.getAttribute('data-type');

switch (typeOf) {
    case 'cart':
        import('./modules/cart/_index.js').then((module) => {
            module.cartDeliveryPoints();
            module.cartCommands();
            module.cartLink();
            module.cartManagement();
            module.cartStepBubbles();
            module.cartPickpointPopup();
        });
        break;
    case 'emptycart':
        import('./modules/exponeaRecs').then((module) => { module.default(typeOf) });
        break;
    case 'user-management':
        import('./modules/management/_index.js').then((module) => {
            module.default();
        });
        break;
    case 'cms':


        //Fancybox.bind('[data-run-fancybox=""]', {
        //    autoFocus: false,
        //    trapFocus: false,
        //    placeFocusBack: false,
        //    groupAll: true,
        //    hideScrollbar: false
        //});


        break;
    case 'listing':
        PjaxCode();
        FilterLoader();
        // po FilterLoader - restoreFilter musi wpiac formularz przed diffem trackingu
        FilterTracking();
        GaListing();
        StickyFilters();
        ScrollRow();
        PriceFiltering();
        TextWrap();

        import('./modules/listing/filter-narrow-down').then((module) => {
            module.default();
        });

        if (document.querySelector('.promo-banners')) {
            import('./modules/listing/promotion-banners').then((module) => {
                module.default();
            });
        }

        break;
    case 'detail':
        DetailMain();
        import('./modules/exponeaRecs').then((module) => { module.default(typeOf) });
        break;
    case 'mainpage':
        import('./modules/exponeaRecs').then((module) => { module.default(typeOf) });
        break;
    case 'advanced-search':
        import('./modules/advanced-search').then((module) => { module.default() });
        break;
    default:
        break;
}

DesktopTree();
ButtonEvents();
Rwd();

WishlistBinding();
WishlistDrawing();
DropdownPicker();
ProductTemplate();
DesktopProducersTree();
Newsletter();
EventReceiver();
ProductAdder();
//Tabs();
CalculateFreeShipment();
QuestionForm();
LoginPopup();
Showcase();
whenIdle(() => VideoPlaceholders());
Faqs();
CopyLink();

// ACCORDION
on('click', '.accordion-trigger', function (e) {
    e.preventDefault();
    this.classList.toggle('info-visible');
});

// HEADER OBERVER
const header = document.querySelector('.shop-header');
const headerSentinel = document.querySelector('.header-sentinel');

if (header) {
    initObserver(headerSentinel, function () {
        header.classList.add('stuck');
    }, function () {
        header.classList.remove('stuck');
    });
}



// LAZY LOAD IMAGES
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazyload',
    unobserve_entered: true,
    cancel_on_exit: false,
});

// INIT TOOLTIPS
const tippyNeeded = document.querySelectorAll('[data-tippy-content]').length > 0;

if (tippyNeeded) {
    whenIdle(() => {
        import('tippy.js').then((module) => {
            module.delegate('body', {
                target: '[data-tippy-content]',
                allowHTML: true,
                appendTo: (el) => {
                    return (el && el.dataset.stickToParent) ? el.parentElement : document.body;
                }

            });
        });
    });
}

// LINKIFY CHAT
// Wejściem innerHTML, nie textContent: ten gubi <br /> (sklejone linie) i odkodowuje encje (XSS) — jak admin/modules/linkify.js.
const threadMessages = document.querySelector('.thread-messages');

if (threadMessages) {
    whenIdle(() => {
        import('linkify-html').then((module) => {
            threadMessages.querySelectorAll('.message-body').forEach(function (message) {
                message.innerHTML = module.default(message.innerHTML, { target: "_blank", rel: "noopener" });
            });
        });
    });
}


document.addEventListener("DOMContentLoaded", (event) => {

    performance.mark("DOMContentLoaded triggered")

    whenIdle(smallCartRefresh);

    //ConsentBar();
    RmaForm();

    const immediatePopup = document.querySelector('[data-immediate-popup]');

    if (immediatePopup) {
        const message = immediatePopup.getAttribute('data-immediate-popup');

        if (message && message.trim() !== '') {
            ShowPopup({
                body: message,
                overloadClass: 'error-modal'
            });
        }
    }


    import('./modules/comparison').then((module) => { module.default() });
    whenIdle(() => import('./modules/recaptcha').then((module) => { module.DrawInlineCaptcha() }));
    import('./modules/search-engine').then((module) => { module.default() });
    whenIdle(() => import('./modules/return-to-top').then((module) => { module.default() }));

    // VALIDATIONS
    const toValidateList = document.querySelectorAll('[data-run-validator]');

    if (toValidateList.length > 0) {
        import('./modules/front-validation').then(module => module.default(toValidateList));
    }

    window.showCookie = function (event) {

        if (event) {
            event.preventDefault();
        }

        Cookiebot.renew();
    };

    performance.mark("DOMContentLoaded end")
});


performance.mark("App ends")